import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.update`;

export const INIT = `${SCOPE}/INIT`;
export const UPDATE_DASHBOARD = `${SCOPE}/UPDATE_DASHBOARD`;
export const UPDATE_DASHBOARD_BY_ID = `${SCOPE}/UPDATE_DASHBOARD_BY_ID`;
